import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import classNames from 'classnames';
import { isEmpty, isEqual } from 'lodash';

import { Loader, ErrorText } from "../../../components";
import { ORDER_STATUS } from '../../../constants';
import { formatCategory } from '../../../utils/format';

export default class Details extends Component {
    state = {
        status: '',
        totalAmount: 0,
        invalidAmount: false,
    }

    componentDidUpdate(prevProps) {
        if (isEmpty(prevProps.data) && !isEqual(prevProps.data, this.props.data)) {
            this.setState({ status : this.props.data.status, totalAmount: this.props.data.orderTotal })
        }
    }

    onStatusChange = e => {
        this.setState({ [e.target.name]: e.target.value, invalidAmount: false });
    }

    onSave = () => {
        const { totalAmount } = this.state;

        if (totalAmount === '' || totalAmount < 0) {
            this.setState({ invalidAmount: true });
            return;
        }

        this.props.updateStatus({
            status: this.state.status,
            orderId: this.props.data.id,
            totalAmount,
        })
    }

    render() {
        const { status, totalAmount, invalidAmount } = this.state;
        const { show, onHide, data, loading } = this.props;
        return (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Order Details {data.status ? ( <>- <span 
                            className={classNames('badge text-capitalize', {
                                'badge-success': data.status !== `rejected` || data.staus !== 'failed_payment',
                                'badge-danger' : data.status === 'rejected' || data.status ===`failed_payment`,
                            })}>{formatCategory(data.status)}</span></>) : ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <Loader show={loading} noOverlay />
                    ) : (
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <div className="form-group">
                                    <label>Update Status</label>
                                    <select
                                        name="status"
                                        className="form-control"
                                        value={status}
                                        onChange={this.onStatusChange}
                                    >
                                        {ORDER_STATUS.map(status => <option key={status.value} value={status.value}>{status.name}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mb-2">
                                <div className="form-group">
                                    <label>Total Amount</label>
                                    <input
                                        name="totalAmount"
                                        type="number" 
                                        className={classNames('form-control', { 'is-invalid': invalidAmount })}
                                        value={totalAmount}
                                        onChange={this.onStatusChange}
                                        maxLength="10"
                                    />
                                    <ErrorText error={invalidAmount && 'Invalid Amount'}/>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Size</th>
                                            <th>Units</th>
                                            <th>Price</th>
                                            <th>Total</th>
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {console.log(data.items)}
                                        {data.items && data.items.length && data.items.map(product => (
                                            <tr key={product.id}>
                                                <td>{product.name}</td>
                                                <td>{product.size}</td>
                                                <td>{product.units}</td>
                                                <td>{product.price.toFixed(2)}</td>
                                                <td>{(product.units * product.price || 0).toFixed(2)}</td>
                                                <td className="text-danger">{product.isCancelled==0?"":"Cancelled"}</td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col-md-7"/>
                                    <div className="col-md-4">
                                        <div className="d-flex">
                                            <div className="flex-1">
                                                Value:
                                            </div>
                                            <div className="flex-1 d-flex justify-content-end">
                                                {parseFloat(data.orderValue || 0).toFixed(2)}
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="flex-1">
                                                GST:
                                            </div>
                                            <div className="flex-1 d-flex justify-content-end">
                                                {data.gst}
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="flex-1">
                                                Delivery Charge:
                                            </div>
                                            <div className="flex-1 d-flex justify-content-end">
                                                {data.deliveryCharge}
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="flex-1">
                                                <h4>Total:</h4>
                                            </div>
                                            <div className="flex-1 d-flex justify-content-end">
                                               <h4> {data.orderTotal}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={onHide}>Close</button>
                    <button className="btn btn-primary" onClick={this.onSave}>Save</button>
                </Modal.Footer>
            </Modal>
        )
    }
};